import React, { FC, useEffect } from "react";
import "./CreateRequest.css";
import { Message } from "primereact/message";

export const SubmittedNewRequest: FC = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex justify-content-center p-2">
      <div style={{display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "white", padding: 10, borderRadius: 10, minHeight: 400}} className="card flex align-items-center flex-column pt-6 px-3">
        <i className="pi pi-check-circle" style={{ fontSize: "5rem", color: "var(--green-500)" }}></i>
        <Message style={{ width: "100%", fontWeight: "bold", marginTop: 20 }}
                 text="Twoje zgłoszenie o zastępstwo zostało wysłane!"
                 severity="success" />
      </div>
    </div>
  );
};

export default SubmittedNewRequest;